import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import ListIcon from '@material-ui/icons/List';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField/TextField";
import Map from "./Map";
import { Context } from "./ContextProvider";
import LoadingResults from "./LoadingResults";
import ItinerariesList from "./ItinerariesList";
import { withWidth } from "@material-ui/core";
import QueryForm from "./QueryForm";
import Logo from "./Logo";
import ItineraryDetailMobile from "./ItineraryDetailMobile";
import * as Consts from "./Consts";
import axios from 'axios';
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent/SnackbarContent";
import CloseIcon from '@material-ui/icons/Close';
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import { useTranslation } from 'react-i18next';
import { addItiIds, generateId } from "./Helpers";
import * as Logger from "./Logger";
import i18next from 'i18next';


const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        height: '100%',
    },
    drawerOpened: {
        width: Consts.drawerWidth,
        flexShrink: 0,
        marginTop: Consts.barHeigth + theme.spacing.unit * 2,
    },
    drawerClosed: {
        flexShrink: 0,
        marginTop: Consts.barHeigth + theme.spacing.unit * 2,
    },
    mobileLayoutInformationPanel: {
        marginTop: Consts.mobileBarHeight,
        width: "100%",
    },
    hideDrawerButton: {
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },

    drawerPaper: {
        width: Consts.drawerWidth,
    },
    content: {
        flexGrow: 1,

    },
    menuButton: {
        color: "white",
    },
    title: {
        color: "white",
    },
    snackbarContent: {
        backgroundColor: theme.palette.error.dark,
    },
    mapContainer: {
        [theme.breakpoints.down('sm')]: {
            height: `calc(100% - ${Consts.barHeigth}px - ${Consts.mobileFooterHeigth}px)`,
        },
        [theme.breakpoints.up('md')]: {
            height: `calc(100% - ${Consts.barHeigth}px)`,
        },

        marginTop: Consts.barHeigth,
        marginBotton: Consts.mobileFooterHeigth,
    },

}));


function ResponsiveDrawer(props) {
    const { t, i18n } = useTranslation();

    let { state, dispatch } = React.useContext(Context);
    const { container } = props;
    const classes = useStyles();
    const theme = useTheme();

    Logger.log("State is")
    Logger.log(state)

    // determine the type of the layout, l - large (pc), m - medium (tablet), s - small (mobile)
    const layoutSize = (props.width === "lg" || props.width === "xl" ? "l" :
        props.width === "sm" || props.width === "xs" ? "s" : "m");

    if (layoutSize !== state.layoutSize)
        dispatch({ type: "setLayoutSize", payload: layoutSize })


    const [showLoadingSpinner, setShowLoadingSpinner] = React.useState(false);
    const [leftBarOpen, setLeftBarOpen] = React.useState(layoutSize !== "l");
    const [errorMessage, setErrorMessage] = React.useState("");
    const [area, setArea] = React.useState("");
    const [language, setLanguage] = React.useState();

    const [loadingColors, setLoadingColors] = React.useState(false);
    const [loadingConfig, setLoadingConfig] = React.useState(false);
    const [loadingElectricConfig, setLoadingElectricConfig] = React.useState(false);
    const [loadingChargersTypes, setLoadingChargersTypes] = React.useState(false);
    const [loadingTemperatures, setLoadingTemperatures] = React.useState(false);
    const [loadingOperators, setLoadingOperators] = React.useState(false);
    const [loadingStations, setLoadingStations] = React.useState(false);

    // determines the state app is, can be: s - search, r - result, m - map (mobile only)
    const toResults = () => dispatch({ type: "setAppState", payload: "r" })
    const toSearch = () => dispatch({ type: "setAppState", payload: "s" })
    const toMap = () => dispatch({ type: "setAppState", payload: "m" })


    if (language === undefined) {
        if (state.config && state.config.languages !== undefined && i18next.language) {
            setLanguage(i18next.language);
        }
    }
    //loading config
    function loadJSON(filepath, callback) {
        const xobj = new XMLHttpRequest();
        xobj.overrideMimeType("application/json");
        xobj.open('GET', filepath, true);
        xobj.onreadystatechange = function () {
            if (xobj.readyState == 4 && xobj.status == "200") {
                callback(xobj.responseText);
            }
        };
        xobj.send(null);
    }

    // loading config files
    if (!state.colors && !loadingColors) {
        setLoadingColors(true);
        loadJSON('./config/colors.json', function (response) {
            setLoadingColors(false);
            Logger.log("loaded colors");
            Logger.log(JSON.parse(response));
            dispatch({ type: "loadColors", payload: JSON.parse(response) })
        });
    }
    if (!state.config && !loadingConfig) {
        setLoadingConfig(true);
        loadJSON('./config/config.json', function (response) {
            setLoadingConfig(false);
            Logger.log("loaded config")
            const respAsJson = JSON.parse(response)
            Logger.log(respAsJson);

            // setting area and moving default map center to the area center
            const defaultArea = respAsJson.areas.find(function (elem) {
                return elem.default === true
            })
            Logger.log("default area is");
            Logger.log(defaultArea);

            dispatch({ type: "changeDefaultMapCenter", payload: { lat: defaultArea.lat, lng: defaultArea.lng } });
            dispatch({ type: "loadConfig", payload: respAsJson });
            setArea(defaultArea);
        });
    }

    getAreaSpecyficData(area.id);

    function getAreaSpecyficData(areaId) {
        if (state.config && !loadingOperators && !state.operators && area.id) {
            setLoadingOperators(true);
            axios.get(state.config.serverUrl + "/etplanner/routers/[routerID]/electricCarSharingOperator/list".replace("[routerID]", area.id))
                .then(res => {
                    Logger.log("getting operators response");
                    Logger.log(res)
                    if (res.data.error) {
                        const { msg } = res.data.error;
                        setErrorMessage(msg);
                    } else {
                        setLoadingOperators(false);
                        Logger.log("loaded operators types");
                        Logger.log(res.data)
                        dispatch({ type: "loadedOperators", payload: res.data.operators });
                    }
                }).catch(error => {
                    setErrorMessage("Error calling server");
                })
        }



        if (state.config && !loadingStations && !state.stations && area.id) {
            setLoadingStations(true);
            axios.get(state.config.serverUrl + "/etplanner/routers/[routerID]/charging/list".replace("[routerID]", area.id))
                .then(res => {
                    Logger.log("getting charging stations response");
                    Logger.log(res)
                    if (res.data.error) {
                        const { msg } = res.data.error;
                        setErrorMessage(msg);
                    } else {
                        setLoadingStations(false);
                        Logger.log("loaded charging stations types");
                        Logger.log(res.data)
                        dispatch({ type: "loadedStations", payload: res.data.stations });
                    }
                }).catch(error => {
                    setErrorMessage("Error calling server");
                })
        }

        if (!state.electricConfig && !loadingElectricConfig && state.config && area.id) {
            setLoadingElectricConfig(true);
            Logger.log("area id is " + area.id)
            axios.get(state.config.serverUrl + "/etplanner/routers/[routerID]/metadata".replace("[routerID]", area.id))
                .then(res => {
                    Logger.log("getting metadata response");
                    Logger.log(res)
                    if (res.data.error) {
                        const { msg } = res.data.error;
                        setErrorMessage(msg);
                    } else {
                        setLoadingElectricConfig(false);
                        Logger.log("loaded electric types");
                        dispatch({ type: "loadElectricConfig", payload: res.data.carDefinitionMap });
                        dispatch({ type: "loadMetadata", payload: res.data });
                    }
                }).catch(error => {
                    setErrorMessage("Error calling server");
                })
        }
    }

    if (!state.electricPlugTypeConfig && !loadingChargersTypes) {
        setLoadingChargersTypes(true);
        loadJSON('./config/chargers.json', function (response) {
            setLoadingChargersTypes(true);
            Logger.log("loaded charger plug types");
            dispatch({ type: "loadChargerPlugTypeConfig", payload: JSON.parse(response) });
        });
    }

    if (area && !state.temperatures) {
        getAreaTemperatures(area);
    }

    function getAreaTemperatures(area) {
        if (!loadingTemperatures) {
            Logger.log("getting temperatures for area " + area.id);
            setLoadingTemperatures(true);
            loadJSON('./config/temperatures/' + area.id + '.json', function (response) {
                setLoadingTemperatures(false);
                Logger.log("loaded temperatures for " + area.id + " area");
                dispatch({ type: "temperatures", payload: JSON.parse(response) });
            });
        }
    }

    function query(q) {
        setErrorMessage("");
        setShowLoadingSpinner(true);
        axios.get((state.config.serverUrl + "/etplanner/routers/[routerID]/plan").replace("[routerID]", area.id), { params: q })
            .then(res => {
                Logger.log("got response");
                Logger.log(res)
                if (res.data.error) {
                    const { msg } = res.data.error;
                    setErrorMessage(msg);
                } else {
                    handleResponse(res.data);
                }
            }).catch(error => {
                setErrorMessage("Error calling server");
            })

    }

    function handleResponse(response) {
        dispatch({ type: "receivedItineraries", payload: addItiIds(response) })
        if (response.plan.itineraries.length > 0) {
            dispatch({ type: "selectIti", payload: response.plan.itineraries[0].id });
        }
        toResults();
        setShowLoadingSpinner(false)
    }

    function handleOpenSearch() {
        setLeftBarOpen(true);
        toSearch();
    }

    function handleOpenResults() {
        setLeftBarOpen(true);
        toResults();
    }

    function handleCloseLeft() {
        setLeftBarOpen(false);
    }

    // VISUAL ELEMENTS ARE DEFINED HERE
    const itinerariesList = (<ItinerariesList />)
    const queryForm = (<QueryForm onSubmit={query} onCloseMenu={handleCloseLeft} />);
    const mainMap = (<main className={classes.content}>
        <div className={classes.mapContainer}>
            <Map />
        </div>
    </main>);

    const notMobileContent = (<React.Fragment>
        <nav className={leftBarOpen || layoutSize === "l" ? classes.drawerOpened : classes.drawerClosed}>
            <Hidden lgUp implementation="css">
                <Drawer
                    container={container}
                    variant="persistent"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={leftBarOpen}
                    onClose={handleOpenSearch}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    {state.appState === "s" && queryForm}
                    {(state.appState === "r" || state.appState === "m") && itinerariesList}
                </Drawer>
            </Hidden>
            <Hidden mdDown implementation="css">
                <Drawer
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    variant="permanent"
                    open
                >
                    {state.appState === "s" && queryForm}
                    {(state.appState === "r" || state.appState === "m") && itinerariesList}
                </Drawer>
            </Hidden>
        </nav>
        {mainMap}
    </React.Fragment>);

    // DECIDE WHICH ELEMENT DISPLAY DEPENDANT ON CONDITIONS (SCREEN SIZE AND APP STATE)
    let content = <div>Empty :(</div>;

    if (layoutSize !== "s") { // PC and tablet content layout
        content = notMobileContent;
    } else { // mobile layout logic
        Logger.log("mobile layout");
        if (state.appState === "s") {
            Logger.log("Showing search")
            content = <div class={classes.mobileLayoutInformationPanel}>{queryForm}</div>
        } else if (state.appState === "r") {
            Logger.log("Showing results");
            content = <div class={classes.mobileLayoutInformationPanel} >{itinerariesList}</div>
        } else if (state.appState === "m") {
            Logger.log("Showing map")
            content = <React.Fragment>
                {mainMap}
                <ItineraryDetailMobile />
            </React.Fragment>
        }

    }

    function closeError() {
        setErrorMessage("");
        setShowLoadingSpinner(false);
    }

    function getAreas() {
        if (state.config && state.config.areas) {
            return state.config.areas.map((area) => <option value={area}>{t(area.displayName)}</option>)
        }
        return "";
    }

    function updateMetadata(areaid) {
        console.log("getting metadata for area " + areaid);
        //KRZI clearing old data

        dispatch({ type: "clearAreaData", payload: {} });
        //making api calls
        getAreaSpecyficData(areaid);

    }


    function handleAreaChange(event) {
        const { value } = event.target;
        setArea(value);
        getAreaTemperatures(value);
        dispatch({ type: "setAppState", payload: "s" });
        dispatch({ type: "changeDefaultMapCenter", payload: { lat: value.lat, lng: value.lng } });
        dispatch({ type: "receivedItineraries", payload: undefined })
        dispatch({ type: "setStartOnMap", payload: undefined });
        dispatch({ type: "setEndOnMap", payload: undefined });
        dispatch({ type: "setStartDisplayName", payload: undefined });
        dispatch({ type: "setEndDisplayName", payload: undefined });
        updateMetadata(value);
    }

    function handleLanguageChange(event) {
        console.log("changing language to " + event.target.value)
        i18next.changeLanguage(event.target.value, (err, t) => {
            if (err) return Logger.log('something went wrong changing translation', err);
            t('key'); // -> same as i18next.t);}
        });
        setLanguage(event.target.value)
    }

    function createLanguageSelector() {
        const { languages } = i18next;

        if (state.config && state.config.languages) {
            return <TextField
                style={{}}
                id="region"
                label={t("Language")}
                select
                onChange={handleLanguageChange}
                value={language}
            >
                {state.config.languages.map((l) => <option value={l}>{l}</option>)}
            </TextField>
        }
    }


    return (
        <div className={classes.root}>
            <CssBaseline />
            <LoadingResults showLoading={showLoadingSpinner} />
            <Snackbar open={errorMessage !== ""}>
                <SnackbarContent
                    className={classes.snackbarContent}
                    aria-describedby="client-snackbar"
                    message={
                        <span id="client-snackbar" className={classes.message}>
                            <Icon />
                            {errorMessage}
                        </span>
                    }
                    action={[

                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className={classes.close}
                            onClick={closeError}
                        >
                            <CloseIcon className={classes.icon} />
                        </IconButton>,
                    ]}
                />
            </Snackbar>
            <AppBar position="fixed" className={classes.appBar}>
                {(layoutSize === "s") && <Toolbar>
                    <img style={{ width: "50%" }} src="./img/logoMobileLeft.jpg" /><img style={{ width: "50%" }} src="./img/logoMobileRight.jpg" /></Toolbar>}
                <Toolbar>
                    {(layoutSize === "l" || layoutSize === "m") && <img style={{ marginLeft: "10px", height: "60px" }} src="./img/logoLeft.jpg" />}

                    <Tooltip title={t("Search")}>

                        <IconButton
                            aria-label="Search"
                            onClick={handleOpenSearch}
                            className={classes.menuButton}
                        >
                            <SearchIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t("Result list")}>
                        <IconButton
                            aria-label="Results"
                            onClick={handleOpenResults}
                            className={classes.menuButton}
                            disabled={state.itineraries ? false : true}
                        >
                            <ListIcon />
                        </IconButton>
                    </Tooltip>
                    <Typography variant="h6" color="inherit" noWrap className={classes.title}>
                        ET Planner
                    </Typography>
                    <TextField
                        style={{
                            width: "150px"
                            , marginLeft: "auto"
                        }}
                        id="region"
                        select
                        onChange={handleAreaChange}
                        value={area} // temporary, make it dynamic
                        label={t("Select Region")}
                    >
                        {getAreas()}
                    </TextField>
                    {createLanguageSelector()}
                    {(layoutSize === "l" || layoutSize === "m") && <img style={{ marginLeft: "10px", height: "60px" }} src="./img/logoRight.jpg" />}
                </Toolbar>

            </AppBar>
            {content}
        </div>
    );
}


export default withWidth()(ResponsiveDrawer);
